import type StudyQuestionModel from '../../../models/StudyQuestionModel';
import { requestAndParse, requestSuccessful } from '../request';

const getStudyQuestions = async (studyId?: number) => {
    const route = 'admin/get-study-questions';
    const payload = { studyId };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const questions = (response.body?.questions ?? []) as StudyQuestionModel[];

    return { success, questions };
};

export default getStudyQuestions;
